// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
// Assurez-vous que global.css est importé ici
import './styles/global.css'; // <--- C'est l'import important
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// SILENCE POCKETBASE GHOST ERRORS (ClientResponseError 0)
// This is a development-only annoyance related to how React handles 
// transient real-time connection interruptions. 
if (process.env.NODE_ENV === 'development') {
  const isGhostError = (err) => {
    if (!err) return false;
    const status = err.status || err.originalError?.status;
    const name = err.name || err.originalError?.name;
    const message = err.message || err.originalError?.message || "";
    const data = err.data || err.originalError?.data || {};

    // Silencing logic for:
    // 1. Transient connection issues (status 0)
    // 2. Missing 'status' field in timesheets (standard for this project's transition)
    return (
      status === 0 ||
      name === 'ClientResponseError' ||
      String(message).includes('ClientResponseError 0') ||
      (status === 400 && (String(message).includes('status') || JSON.stringify(data).includes('status')))
    );
  };

  // Aggressive silencing for the React Error Overlay
  window.addEventListener('unhandledrejection', (event) => {
    if (isGhostError(event.reason)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  });

  window.addEventListener('error', (event) => {
    if (isGhostError(event.error) || isGhostError(event.reason)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  });

  // Patch console.error to avoid logging these technical interruptions
  const originalError = console.error;
  console.error = (...args) => {
    if (isGhostError(args[0]) || (typeof args[0] === 'string' && args[0].includes('ClientResponseError 0'))) {
      return;
    }
    originalError.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// Disable Service Worker that might interfere with Real-time (SSE/EventSource)
serviceWorkerRegistration.unregister();

reportWebVitals();
